import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useQuery } from "@tanstack/react-query";

export function useActiveSuppliesPromotion() {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const { data } = useQuery({
    queryKey: ["redo-supplies-active-promotion"],
    queryFn: () => rpcClient.getActiveSuppliesPromotion({}),
  });
  return data?.promotion ?? null;
}
